<template>
  <div id="menu-detail">
    <a @click="backPage" v-if="menuDetail.imageUrl != 'restaurant/add_menu_edit_no_image.png'" class="close-page">
      <i class="el-dialog__close el-icon el-icon-close"></i>
    </a>
    <div class="m-l-10 pt-4" v-else @click="backPage">
      <i class="el-dialog__close el-icon el-icon-close"></i>
    </div>
    <!-- Edit Menu -->
    <el-row v-if="this.$route.query.action == 'editCart'">
      <MenuDetailHeader :menu-detail="menuDetail" :loading="loading" />

      <MenuOptionLoader :loading="loading">
        <el-col :span="24" class="text-left box-menu" v-for="(goption, index) in optionGroups" :key="index">
          <div class="option-contrainer" v-if="goption">
            <el-row>
              <el-col :span="19">
                <p class="menu-option-name">{{ goption.name }}</p>
                <label v-if="goption.isRequired" class="max-choice">
                  {{ $t("pageMenuDetail.must") }} {{ goption.maxChoice }}
                </label>
                <label v-if="!goption.isRequired && goption.maxChoice > 0" class="max-choice">
                  {{ $t("pageMenuDetail.max") }} {{ goption.maxChoice }}
                </label>
              </el-col>
              <el-col :span="5">
                <el-button class="require-tag float-right m-r-8" size="mini" type="danger" plain v-if="goption.isRequired && goption.maxChoice > 0" disabled>{{ $t("pageMenuDetail.must") }}
                  {{ goption.maxChoice }}</el-button>
                <el-button class="not-require-tag float-right m-r-8" size="mini" type="info"
                  plain
                  v-if="!goption.isRequired && goption.maxChoice > 0"
                  disabled
                  >{{ $t("pageMenuDetail.if") }}</el-button
                >
              </el-col>
            </el-row>

            <div class="choice-contrainer">
              <div v-for="(option, i) in goption.options" :key="i">
                <div
                  class="choice-line"
                  v-if="goption.isRequired === true && goption.maxChoice === 1"
                >
                  <label
                  v-if="!option.outOfStock"
                    :id="'label-' + option.option_group_id + '-' + option.id"
                    v-bind:class="
                      editMenuOptions.findIndex(
                        (element) =>
                          element.option_group_id === option.option_group_id &&
                          element.seq === option.seq
                      ) === -1
                        ? 'radio-choice-name radio-container'
                        : 'radio-choice-name radio-container fw-lg'
                    "
                    ><em class="fs-entry-title">{{ option.name }}</em>
                    {{
                      option.price === "0.00"
                        ? ""
                        : "+ "+ price_format(option.price,currency)
                    }}
                    <input
                      type="radio"
                      :checked="
                        editMenuOptions.findIndex(
                          (element) =>
                            element.option_group_id ===
                              option.option_group_id &&
                            element.seq === option.seq
                        ) === -1
                          ? false
                          : true
                      "
                      class="radio-container"
                      :name="option.option_group_id"
                      :value="option.name"
                      @change="
                        addOption(
                          goption,
                          option,
                          index,
                          i,
                          'radio',
                          $event,
                          'editCart'
                        )
                      "
                    />
                    <span class="checkmark"></span>
                  </label>

                    <label
                    v-else
                    :id="'label-' + option.option_group_id + '-' + option.id"
                    class="radio-choice-name radio-container">
                 
                      <em  class="text-out-of-stock">{{ option.name }}</em>
                    <input
                      type="radio"
                      class="radio-container"
                      disabled
                    />
                    <span class="checkmark-out-of-stock"></span>
                  </label>
                   <el-col :span="8" class="pr-2">
                    <el-button class="not-require-tag float-right m-r-12"
                     size="mini" type="info" plain v-if="option.outOfStock" disabled>
                     {{ $t('pageMenuDetail.outOfStock') }}</el-button>
                   </el-col>
                </div>
                <div class="choice-line " v-else-if="option.outOfStock">
                  <el-col :span="16" class="pr-2">
                          <label
                      class="choice-name radio-container "
                    >
                      <em class="fs-entry-title text-out-of-stock">
                        {{ option.name }}
                        <label class="max-choice"> </label>
                      </em>
                      <span class="checkmark checkmark-checkbox out-of-stock"></span>

                      <el-row> </el-row>
                    </label>
                  </el-col>

                        <el-col :span="8" class="pr-2">
				       <el-button class="not-require-tag float-right m-r-12" size="mini" type="info" plain v-if="option.outOfStock" disabled>{{ $t('pageMenuDetail.outOfStock') }}</el-button>
                        </el-col>

                <!-- <el-button class="not-require-tag float-right m-r-12" size="mini" type="info" plain v-if="option.outOfStock" disabled>{{ $t('pageMenuDetail.outOfStock') }}</el-button> -->

                </div>
              
                <div class="choice-line" v-else>
                  <el-col :span="16">
                    <label
                      :id="'label-' + option.option_group_id + '-' + option.id"
                      v-bind:class="
                        editMenuOptions.findIndex(
                          (element) =>
                            element.option_group_id == option.option_group_id &&
                            element.seq == option.seq
                        ) == -1
                          ? 'choice-name radio-container'
                          : 'choice-name radio-container fw-lg'
                      "
                    >
                      <em
                        v-bind:class="
                          option.price == '0.00' && count[0][index][i].num > 0
                            ? 'mt-75 fs-entry-title'
                            : 'fs-entry-title'
                        "
                        >{{ option.name }} </em>
                      {{
                        option.price == "0.00"
                          ? ""
                          : "+ " + price_format(option.price,currency)
                      }}
                      <input
                        :id=" 'input-' + option.option_group_id + '-' + option.id"
                        type="checkbox"
                        :checked="editMenuOptions.findIndex(
                            (element) => element.option_group_id === option.option_group_id && element.seq === option.seq
                          ) === -1
                            ? false
                            : true
                        "
                        class="radio-container"
                        :name="option.option_group_id"
                        :value="option.name"
                        @change="
                          addOption(
                            goption,
                            option,
                            index,
                            i,
                            'checkbox',
                            $event,
                            'editCart'
                          )
                        "
                      />
                      <span class="checkmark checkmark-checkbox"></span>
                    </label>
                  </el-col>
                  <el-col :span="8" class="pr-2">
                    <el-row
                      :id="
                        'counter-' + option.option_group_id + '-' + option.id
                      "
                      v-if="!(goption.isRequired && goption.maxChoice === 1)"
                      v-show="
                        editMenuOptions.findIndex(
                          (element) =>
                            element.option_group_id ===
                              option.option_group_id &&
                            element.seq === option.seq
                        ) === -1
                          ? displayOptions[option.id]
                          : true
                      "
                    >
                      <el-col :span="24" class="fs-count option">
                        <el-row class="input-number">
                          <el-col
                            :span="8"
                            @click.native="
                              decreaseOption(
                                index,
                                i,
                                option,
                                goption,
                                'editCart'
                              )
                            "
                            class="btn text-center"
                          >
                            <i
                              class="fas fa-minus"
                              style="vertical-align: middle"
                            ></i>
                          </el-col>
                          <el-col :span="8" class="btn text-center">
                            {{
                              count[0] &&
                              count[0][index] &&
                              count[0][index][i] &&
                              count[0][index][i].num
                            }}
                          </el-col>
                          <el-col
                            :span="8"
                            @click.native="
                              increaseOption(
                                index,
                                i,
                                option,
                                goption,
                                'editCart'
                              )
                            "
                            class="btn text-center"
                          >
                            <i
                              class="fas fa-plus"
                              style="vertical-align: middle"
                            ></i>
                          </el-col>
                        </el-row>
                      </el-col>
                    </el-row>
                  </el-col>
                </div>
                <hr v-if="i != goption.options.length - 1" class="hr-choice" />
              </div>
            </div>
          </div>
        </el-col>
      </MenuOptionLoader>

      <el-col
        :span="24"
        :class="
          menuDetail.imageUrl != 'restaurant/add_menu_edit_no_image.png'
            ? 'text-left box-menu'
            : 'text-left no-img'
        "
        style="padding-bottom: 140px"
      >
        <el-card :body-style="{ padding: '16px' }">
          <label class="text-heading3">{{ $t("pageMenuDetail.note") }}</label>
          <el-input
            :ref="'notaion'"
            class="mt--2 text-subtitle overide-textarea"
            row="300"
            type="textarea"
            :placeholder="$t('without.text1')"
            maxlength="50"
            v-model="Notaion"
          >
          </el-input>
        </el-card>
      </el-col>

      <el-col :span="24" class="fs-footer-cart" v-if="EditMenu">
        <el-row>
          <el-col :span="24">
            <elementMenuDetail
              @toggle_total_price="activeTotalPrice"
              :menudetail="EditMenu"
              :options="multioption"
              :notaion="Notaion"
              :flag="'editCart'"
              :loading="loading"
            />
          </el-col>
        </el-row>
        <el-row>
          <el-col class="px--4 pb--4">
            <BaseButton
              class="color-primary color-white--text full-width text--button"
              style="border-radius: 10px"
              :loading="isConfirmButtonLoading"
              @click="() => checkoutToCart('editCart')"
            >
              {{ $t("pageMenuDetail.editToCart") }}
            </BaseButton>
          </el-col>
        </el-row>
      </el-col>
    </el-row>

    <!-- Add Menu -->
    <el-row v-else>
      <MenuDetailHeader :menu-detail="menuDetail" :loading="loading" />

      <MenuOptionLoader :loading="loading">
        <el-col
          :span="24"
          class="text-left box-menu"
          v-for="(goption, index) in optionGroups"
          :key="index"
        >
          <div class="option-contrainer">
            <el-row>
              <el-col :span="19">
                <p class="menu-option-name">{{ goption.name }}</p>
                <label v-if="goption.isRequired" class="max-choice">
                  {{ $t("pageMenuDetail.must") }} {{ goption.maxChoice }}
                </label>
                <label
                  v-if="!goption.isRequired && goption.maxChoice > 0"
                  class="max-choice"
                >
                  {{ $t("pageMenuDetail.max") }} {{ goption.maxChoice }}
                </label>
              </el-col>
              <el-col :span="5">
                <el-button
                  class="require-tag float-right m-r-8"
                  size="mini"
                  type="danger"
                  plain
                  v-if="goption.isRequired && goption.maxChoice > 0"
                  disabled
                >
                  {{ $t("pageMenuDetail.must") }} {{ goption.maxChoice }}
                </el-button>
                <el-button
                  class="not-require-tag float-right m-r-8"
                  size="mini"
                  type="info"
                  plain
                  v-if="!goption.isRequired && goption.maxChoice > 0"
                  disabled
                >
                  {{ $t("pageMenuDetail.if") }}
                </el-button>
              </el-col>
            </el-row>

            <div class="choice-contrainer">
              <div v-for="(option, i) in goption.options" :key="i">
                <div
                  class="choice-line"
                  v-if="goption.isRequired === true && goption.maxChoice === 1">
                  <label
                  v-if="!option.outOfStock"
                    :id="'label-' + option.option_group_id + '-' + option.id"
                    class="radio-choice-name radio-container">
                 
                      <em  class="fs-entry-title">{{ option.name }}</em>
                         {{
                      option.price === "0.00"
                        ? ""
                        : "+ " + price_format(option.price,currency)
                    }}
                    <input
                      type="radio"
                      class="radio-container"
                      :name="option.option_group_id"
                      :value="option.name"
                      @change="addOption(goption,option,index,i,'radio',$event,'addCart')"
                    />
                    <span class="checkmark"></span>
                  </label>

                  <label
                    v-else
                    :id="'label-' + option.option_group_id + '-' + option.id"
                    class="radio-choice-name radio-container">
                 
                      <em  class="text-out-of-stock">{{ option.name }}</em>
                    <input
                      type="radio"
                      class="radio-container"
                      disabled
                    />
                    <span class="checkmark-out-of-stock"></span>
                  </label>
                   <el-col :span="8" class="pr-2">
                    <el-button class="not-require-tag float-right m-r-12"
                     size="mini" type="info" plain v-if="option.outOfStock" disabled>
                     {{ $t('pageMenuDetail.outOfStock') }}</el-button>
                   </el-col>
                </div>


                <div class="choice-line" v-else>
                  <el-col :span="16">
                    <label
                      :id="'label-' + option.option_group_id + '-' + option.id"
                      class="choice-name radio-container"
                      v-if="!option.outOfStock"
                    >
                      <em
                        class="fs-entry-title"
                        :class="{
                          'mt-75':
                            option.price == '0.00' &&
                            count[0][index][i].num > 0,
                        }"
                      >
                        {{ option.name }}
                      </em>
                      {{
                        option.price == "0.00"
                          ? ""
                          : "+ " + price_format(option.price,currency)
                      }}
                      <input
                        :id="
                          'input-' + option.option_group_id + '-' + option.id
                        "
                        type="checkbox"
                        class="radio-container"
                        :name="option.option_group_id"
                        :value="option.name"
                        @change="
                          addOption(
                            goption,
                            option,
                            index,
                            i,
                            'checkbox',
                            $event,
                            'addCart'
                          )
                        "
                      />
                      <span class="checkmark checkmark-checkbox"></span>
                    </label>

                    <label
                      class="choice-name radio-container "
                      v-else
                    >
                      <em class="fs-entry-title text-out-of-stock">
                        {{ option.name }}
                        <label class="max-choice"> </label>
                      </em>
                      <span class="checkmark checkmark-checkbox out-of-stock"></span>

                      <el-row> </el-row>
                    </label>
                  </el-col>
                  <el-col :span="8" class="pr-2">
				          <el-button class="not-require-tag float-right m-r-12" size="mini" type="info" plain v-if="option.outOfStock" disabled>{{ $t('pageMenuDetail.outOfStock') }}</el-button>

                    <el-row
                      :id="
                        'counter-' + option.option_group_id + '-' + option.id
                      "
                      v-if="!(goption.isRequired && goption.maxChoice === 1)"
                      v-show="displayOptions[option.id]"
                    >
                      <el-col :span="24" class="fs-count option">
                        <el-row class="input-number">
                          <el-col
                            :span="8"
                            @click.native="
                              decreaseOption(
                                index,
                                i,
                                option,
                                goption,
                                'addCart'
                              )
                            "
                            class="btn text-center text-button"
                          >
                            <i
                              class="fas fa-minus"
                              style="vertical-align: middle"
                            ></i>
                          </el-col>
                          <el-col :span="8" class="btn text-center text-button">
                            {{
                              count[0] &&
                              count[0][index] &&
                              count[0][index][i] &&
                              count[0][index][i].num
                            }}
                          </el-col>
                          <el-col
                            :span="8"
                            @click.native="
                              increaseOption(
                                index,
                                i,
                                option,
                                goption,
                                'addCart'
                              )
                            "
                            class="btn text-center text-button"
                          >
                            <i
                              class="fas fa-plus"
                              style="vertical-align: middle"
                            ></i>
                          </el-col>
                        </el-row>
                      </el-col>
                    </el-row>
                  </el-col>
                </div>
                <hr v-if="i != goption.options.length - 1" class="hr-choice" />
              </div>
            </div>
          </div>
        </el-col>
      </MenuOptionLoader>

      <el-col
        :span="24"
        class="text-left box-menu text-more"
        :class="{ 'no-img': menuDetail.imageUrl === consts.noImagePath }"
      >
        <div :body-style="{ padding: '16px' }">
          <label class="text-heading3">{{ $t("pageMenuDetail.note") }}</label>
          <el-input
            class="mt--2 text-subtitle overide-textarea"
            row="300"
            type="textarea"
            :placeholder="$t('without.text1')"
            maxlength="50"
            v-model="Notaion"
          />
        </div>
      </el-col>
      <el-col :span="24" class="fs-footer-cart">
        <el-row>
          <el-col :span="24">
            <elementMenuDetail
              @toggle_total_price="activeTotalPrice"
              :menudetail="menuDetail"
              :options="multioption"
              :notaion="Notaion"
              :flag="'addCart'"
              :loading="loading"
            />
          </el-col>
        </el-row>
        <el-row>
          <el-col class="px--4 pb--4">
            <BaseButton
              class="color-primary color-white--text full-width text--button"
              style="border-radius: 10px"
              :loading="isConfirmButtonLoading"
              @click="() => checkoutToCart('addCart')"
            >
              {{ $t("pageMenuDetail.addToCart") }}
            </BaseButton>
          </el-col>
        </el-row>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import elementMenuDetail from "@/components/element/elementMenuDetail";
import fullButton from "@/components/element/fullButton";
import BaseButton from "@/baseComponents/button/BaseButton.vue";
import Mixins from "@/utils/mixins";

import MenuDetailHeader from "@/components/menudetail/MenuDetailHeader.vue";
import MenuOptionLoader from "@/components/menudetail/MenuOptionLoader.vue";

export default {
  name: "MenuDetailPage",
  props: ["restaurant_uuid", "branch_uuid", "menu_uuid"],
  mixins: [Mixins],
  components: {
    elementMenuDetail,
    fullButton,
    MenuDetailHeader,
    MenuOptionLoader,
    BaseButton,
  },
  data: function () {
    return {
      consts: { noImagePath: "restaurant/add_menu_edit_no_image.png" },
      tmptextAddToCart: "",
      textAddToCart: "",
      displayLoadingBtn: false,
      Notaion: "",
      display: false,
      EditMenu: null,
      fullDisplay: false,
      multioption: [],
      options: [],
      displayOptions: [],
      count: [[[]]],
      tmp: [[]],
      loading: false,
      currency: this.$store.getters.currency
    };
  },
  mounted: async function () {
    try {
      this.loading = true;

      if (this.$route.query.action == "editCart") {
        let AmountCart = JSON.parse(
          localStorage.getItem("cart-" + this.BranchDetail.id)
        );
        this.EditMenu = AmountCart[this.$route.query.number];
        this.multioption = this.EditMenu.options;
        this.Notaion = this.EditMenu.notaion;
      } else {
        this.$store.dispatch("setScrollMenuPosition", this.menu_uuid);
      }

      await this.$store.dispatch("updateMenuDetail", {
        restaurant_uuid: this.BranchDetail.restaurant_uuid,
        branch_uuid: this.BranchDetail.id,
        menu_uuid: this.menu_uuid,
      });
    } finally {
      this.loading = false;
    }
  },
  methods: {
    checkOptionLimit(goption){
      if(goption.maxChoice == 0) return
      let dataGroup = this.multioption.filter(({ option_group_id: group_id }) => goption.id === group_id)
      const dataDisable = goption.options.filter(({ id: group_all_id }) => !dataGroup.some(({ id: group_id }) => group_id === group_all_id));
      if(dataGroup.reduce((partial, option) => partial + option.qty, 0) >= goption.maxChoice){
        dataDisable.forEach((res) => { document.getElementById('input-' + res.option_group_id + '-' + res.id).disabled = true })
      }else{
        dataDisable.forEach((res) => { document.getElementById('input-' + res.option_group_id + '-' + res.id).disabled = false })
      }
    },
    backPage: function () {
      if (this.$route.query.action === "editCart") {
        this.$router.push({
          path: `/restaurant/${this.restaurant_uuid}/${this.branch_uuid}/checkout`,
        });
      } else {
        this.$router.push({
          path: `/restaurant/${this.restaurant_uuid}/${this.branch_uuid}`,
        });
      }
    },
    activeTotalPrice: function (obj) {
      // this.displayLoadingBtn = true
      this.displayLoadingBtn = obj.loading;
      this.textAddToCart = "";
      // if (this.displayLoadingBtn) {
      this.tmptextAddToCart =
        obj.action == "addCart"
          ? this.$t("pageMenuDetail.addToCart")
          : this.$t("pageMenuDetail.editToCart");
      // }
      setTimeout(() => {
        this.displayLoadingBtn = false;
        this.textAddToCart = this.tmptextAddToCart;
      }, 300);
    },
    increaseOption: function (gidx, idx, option, goption, action) {
      let index = _.findIndex(this.tmp[0], { gid: goption.id });
      if (this.tmp[0][index].gid === goption.id) {
        if (
          this.tmp[0][index].num <= goption.maxChoice ||
          goption.maxChoice === 0
        ) {
          this.tmp[0][index].num++;
          this.count[0][gidx][idx].num++;
          let mulindex = _.findIndex(this.multioption, {
            option_group_id: option.option_group_id,
            id: option.id,
          });
          let Objoption = Object.assign(option, {
            qty: this.count[0][gidx][idx].num,
          });
          this.multioption.splice(mulindex, 1);
          this.multioption.push(Objoption);
          this.updateOptionToCart(action);
        }
      }
      this.checkOptionLimit(goption)
      // this.$forceUpdate()
    },
    decreaseOption: function (gidx, idx, option, goption, action) {
      let index = _.findIndex(this.tmp[0], { gid: goption.id });
      if (this.count[0][gidx][idx].num !== 1) {
        this.tmp[0][index].num--;
        this.count[0][gidx][idx].num--;
        let mulindex = _.findIndex(this.multioption, {
          option_group_id: option.option_group_id,
          id: option.id,
        });
        let Objoption = Object.assign(option, {
          qty: this.count[0][gidx][idx].num,
        });
        this.multioption.splice(mulindex, 1);
        this.multioption.push(Objoption);
        this.updateOptionToCart(action);
      } else if (this.count[0][gidx][idx].num === 1) {
        let mulindex = _.findIndex(this.multioption, {
          option_group_id: option.option_group_id,
          id: option.id,
        });
        this.multioption.splice(mulindex, 1);
        this.tmp[0][index].num--;
        this.count[0][gidx][idx].num = 1;
        document.getElementById(
          "counter-" + option.option_group_id + "-" + option.id
        ).style.display = "none";
        document.getElementById(
          "input-" + option.option_group_id + "-" + option.id
        ).checked = false;
        document.getElementById(
          "label-" + option.option_group_id + "-" + option.id
        ).style.fontWeight = "300";
        this.updateOptionToCart(action);
      }
      this.checkOptionLimit(goption)
      // this.$forceUpdate()
    },
    checkoutToCart: function (action) {
      let incorrect = this.checkAllOptionRequire(action);
      if (incorrect) {
        this.$store.dispatch("addMenuToCart", {
          restaurant_uuid: this.restaurant_uuid,
          branch_uuid: this.branch_uuid,
          index: action === "editCart" ? this.$route.query.number : null,
          menu:
            action === "editCart"
              ? this.AmountCart[this.$route.query.number]
              : this.menuDetail,
          options: this.multioption,
          branchdetail: this.BranchDetail,
          notaion: this.Notaion,
          flag: action,
        });
      }
    },
    checkAllOptionRequire: function (actionmenu) {
      let checkout = [];
      let options = this.multioption;
      let menuRequire = _.filter(this.menuDetail.optionGroups, ["isRequired", true,]);
      menuRequire.forEach((ele) => {
        let findOption = _.find(options, ["option_group_id", ele.id]);
        if (_.isNil(findOption) ) {
          this.fullDisplay = true;
          let text = `${this.$t("without.text2")} ${ele.name} ${this.$t(
            "without.text3"
          )}`;
          this.$alert(text, this.$t("dialog.alert"), {
            confirmButtonText: this.$t("dialog.ok"),
            callback: (action) => {
              this.fullDisplay = false;
            },
          });
        } else {
       
          let groupOptions = _(options)
            .groupBy("option_group_id")
            .map((objs, key) => {
              return {
                gid: key, 
                qty:  _.sumBy(objs, "qty"),
              };
            })
            .value();
          let index = _.findIndex(groupOptions, ["gid", ele.id]);
          if (groupOptions[index].qty < ele.maxChoice) {
            this.fullDisplay = true;
            let text = `${this.$t("without.text2")} ${ele.name} ${this.$t(
              "without.text3"
            )}`;
            this.$alert(text, this.$t("dialog.alert"), {
              confirmButtonText: this.$t("dialog.ok"),
              callback: (action) => {
                this.fullDisplay = false;
              },
            });
          
        }
        else {
            checkout.push(true);
          }
        }
      });
      if (menuRequire.length === checkout.length ) {
        let incorrect = (value) => value === true;
        return checkout.every(incorrect) ? true : false;
      }
    },
    addOption: function (
      goption,
      option,
      indexGroup,
      indexOption,
      type,
      event,
      action
    ) {
      if (type === "checkbox") {
        // checked checkbox
        if (event.target.checked == true) {
          let Objoption = Object.assign(option, { qty: 1 });
          this.multioption.push(Objoption);
          this.updateOptionToCart(action);

          let index = this.tmp[0].findIndex((ele) => ele.gid === goption.id);

          if (
            this.tmp[0][index].num <= goption.maxChoice ||
            goption.maxChoice === 0
          ) {
            document.getElementById(
              "counter-" + option.option_group_id + "-" + option.id
            ).style.display = "block";
            document.getElementById(
              "label-" + option.option_group_id + "-" + option.id
            ).style.fontWeight = "500";
            this.tmp[0][index].num++;
            this.updateOptionToCart(action);
          } else {
            let mulindex = _.findIndex(this.multioption, {
              option_group_id: option.option_group_id,
            });
            let mulqty = this.multioption[mulindex].qty;
            let mulid = this.multioption[mulindex].id;
            let mulgid = this.multioption[mulindex].option_group_id;

            this.tmp[0][index].num -= mulqty;
            this.tmp[0][index].num++;

            let oldidx = this.count[0][indexGroup].findIndex(
              (ele) => ele.id === mulid
            );
            this.count[0][indexGroup][oldidx].num -= mulqty; //remove count old option
            this.count[0][indexGroup][oldidx].num++;

            document.getElementById(
              "counter-" + mulgid + "-" + mulid
            ).style.display = "none";
            document.getElementById(
              "input-" + mulgid + "-" + mulid
            ).checked = false;
            document.getElementById(
              "label-" + mulgid + "-" + mulid
            ).style.fontWeight = "300";
            this.multioption.splice(mulindex, 1);

            document.getElementById(
              "counter-" + option.option_group_id + "-" + option.id
            ).style.display = "block";
            document.getElementById(
              "input-" + option.option_group_id + "-" + option.id
            ).checked = true;
            document.getElementById(
              "label-" + option.option_group_id + "-" + option.id
            ).style.fontWeight = "500";
            this.updateOptionToCart(action);
          }

          // unchecked checkbox
        } else {
          let mulindex = this.multioption.findIndex(
            (element) =>
              element.id === option.id &&
              element.option_group_id === option.option_group_id
          );
          this.multioption.splice(mulindex, 1);
          this.updateOptionToCart(action);
          document.getElementById(
            "counter-" + option.option_group_id + "-" + option.id
          ).style.display = "none";
          document.getElementById(
            "label-" + option.option_group_id + "-" + option.id
          ).style.fontWeight = "300";
          let index = this.tmp[0].findIndex((ele) => ele.gid === goption.id);
          this.tmp[0][index].num -= this.count[0][indexGroup][indexOption].num;
          this.count[0][indexGroup][indexOption].num = 1;
        }
        this.checkOptionLimit(goption)
        // checked radio
      } else {
        let index = this.multioption.findIndex(
          (element) => element.option_group_id === option.option_group_id
        );
        let Objoption = Object.assign(option, { qty: 1 });
        document.getElementById(
          "label-" + option.option_group_id + "-" + option.id
        ).style.fontWeight = "500";
        if (index != -1) {
          document.getElementById(
            "label-" +
              this.multioption[index].option_group_id +
              "-" +
              this.multioption[index].id
          ).style.fontWeight = "300";
          this.multioption.splice(index, 1, Objoption);
        } else {
          this.multioption.push(Objoption);
        }
        this.updateOptionToCart(action);
      }
    },
    updateOptionToCart: function (action) {
      this.$store.dispatch("updateOptionToCart", {
        branchdetail: this.BranchDetail,
        menu:
          action === "editCart"
            ? this.AmountCart[this.$route.query.number]
            : this.menuDetail,
        options: this.multioption,
        notaion: this.Notaion,
        flag: action,
      });
    },
  },
  computed: {
    isConfirmButtonLoading: function () {
      return (!this.menuDetail.price && this.loading) || this.displayLoadingBtn;
    },
    menuDetail: function () {
      return Object.assign(
        {},
        this.$store.getters.MenuDetail,
        this.$route.params.menu
      );
    },
    editMenuDetail: function () {
      return this.EditMenu || {};
    },
    editMenuOptions: function () {
      return (this.EditMenu && this.EditMenu.options) || [];
    },
    optionGroups: function () {
      return this.menuDetail.optionGroups || [];
    },
    cart: function () {
      return this.$store.getters.cart;
    },
    AmountCart: function () {
      return this.$store.getters.AmountCart;
    },
    BranchDetail: function () {
      return this.$store.getters.BranchDetail;
    },
  },
  watch: {
    optionGroups: function (options = []) {
      options.forEach((element, index) => {
        this.count[0][index] = [];
        if (this.EditMenu === null) {
          if (!(element.isRequired && element.maxChoice === 1)) {
            element.options.forEach((ele, idx) => {
              this.tmp[0].push({
                gid: ele.option_group_id,
                id: ele.id,
                num: 1,
              });
              this.count[0][index].push({
                gid: ele.option_group_id,
                id: ele.id,
                num: 1,
              });
            });
          }
        } else {
          if (!(element.isRequired && element.maxChoice === 1)) {
            let groupOptions = _(this.EditMenu.options)
              .groupBy("option_group_id")
              .map((objs, key) => {
                return {
                  gid: key,
                  qty: _.sumBy(objs, "qty"),
                };
              })
              .value();
            let fidx = _.findIndex(groupOptions, ["gid", element.id]);
            element.options.forEach((ele, idx) => {
              let groupidx = this.EditMenu.options.findIndex(
                (element) => element.option_group_id === ele.option_group_id
              );
              let opidx = this.EditMenu.options.findIndex(
                (element) =>
                  element.option_group_id === ele.option_group_id &&
                  element.id === ele.id
              );
              let ncount = _.isNil(this.EditMenu.options[opidx])
                ? 1
                : this.EditMenu.options[opidx].qty;
              this.tmp[0].push({
                gid: ele.option_group_id,
                id: ele.id,
                num: groupidx === -1 ? 1 : groupOptions[fidx].qty + 1,
              });
              this.count[0][index].push({
                gid: ele.option_group_id,
                id: ele.id,
                num: opidx === -1 ? 1 : ncount,
              });
            });
          }
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.overide-textarea {
  /deep/ {
    .el-textarea__inner {
      resize: none;
      padding: 8px 12px;
      border-radius: 7px;
      appearance: none;
      -moz-appearance: none;
      -webkit-appearance: none;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/menudetail/MenuDetailPage.vue